module.exports = __webpack_public_path__ + "static/media/Icone_Logo.aafacef4.png";